import React, { useEffect, FC, useRef } from 'react';
import styled from '@emotion/styled';
import { useDrop } from 'react-dnd';
import { useI18n } from '~/Hooks';
import itemsType from '~Scenes/Tables/Components/dragItemsType';
import Icon from '~ComponentsImproved/Icon';
import BackIcon from '~/Assets/icons/arrow_back.svg';

const Wrapper = styled.div<{
  isOver: boolean;
  canDrop: boolean;
}>`
  background: var(--colorBlueGray1300);
  color: #fff;
  border: ${({ isOver }) => (isOver ? '2px solid #ffc000' : 'none')};
  border-radius: 4px;
  width: 64px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.24px;
  text-transform: uppercase;
  box-sizing: border-box;
  position: relative;
  height: 60px;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  animation: fade-and-translate-left 0.4s ease-in-out;
`;

interface Props {
  goToTables: () => void;
}

const DragChequeToTable: FC<Props> = ({ goToTables }) => {
  const { i18n } = useI18n();
  const timer = useRef<number | undefined>();

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [itemsType.CHEQUE],
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  useEffect(() => {
    if (isOver) {
      timer.current = window.setTimeout(() => {
        goToTables();
      }, 400);
    } else {
      if (timer.current !== undefined) {
        window.clearTimeout(timer.current);
      }
    }

    return () => {
      if (timer.current !== undefined) {
        window.clearTimeout(timer.current);
      }
    };
  }, [isOver]);

  return (
    <>
      <Wrapper ref={drop} canDrop={canDrop} isOver={isOver}>
        <Icon src={BackIcon} />
        {i18n('Handy.Page.tables')}
      </Wrapper>
    </>
  );
};

export default DragChequeToTable;
